import { Routes, Route, useSearchParams, useLocation } from 'react-router-dom'

import CheckOptions from './components/CheckOptions';
import OpenbankingCallback from './components/OpenbankingCallback';
import OpenbankingStart from './components/OpenbankingStart';
import IdentityCheck from './components/IdentityCheck';
import { useEffect, useState } from 'react';
import { initStore } from './store/Actions';
import OtpCallback from './components/OtpCallback';
import OtpCheck from './components/OtpCheck';
import NotFound from './components/NotFound';
import Loader from './components/common/Loader';
import OtpMail from './components/OtpMail';
import BankingTransferStart from './components/BankingTransferStart';
import BankingTransferCallback from './components/BankingTransfertCallback';
import BuyerSearch from './components/BuyerSearch';
import BuyerIdentification from './components/BuyerIdentification';
import Quotation from './components/Quotation';
import Layout from './components/common/Layout';


const App = () => {

  const [isResourceLoaded, setIsResourceLoaded] = useState(false)
  const [params] = useSearchParams()

  const location = useLocation()

  useEffect(() => {
    initStore(params, () => setIsResourceLoaded(true))
  }, [])

  return (
    <>
      {isResourceLoaded ? 
        <Routes>
          <Route path="/" element={<BuyerIdentification />} />
          <Route path="/Quotation" element={<Quotation/>} />
          <Route path="/CheckOptions" element={<CheckOptions />} />
          <Route path="/OpenbankingCallback" element={<OpenbankingCallback />} />
          <Route path='/OpenBankingStart' element={<OpenbankingStart />} />
          <Route path="/IdentityCheck" element={<IdentityCheck />} />
          <Route path="/OtpCheck" element={<OtpCheck />} />
          <Route path="/OtpCallback" element={<OtpCallback />} />
          <Route path="/BankingTransferStart" element={<BankingTransferStart />} />
          <Route path="/BankingTransferCallback" element={<BankingTransferCallback />} />
          <Route path="/BuyerSearch" element={<BuyerSearch/>} />
          <Route path="/*" element={<NotFound />} />
          <Route path="/SinglePage" element={<Layout><Loader loading={true} /></Layout>}/>
          { process.env.REACT_APP_ENV === 'Demoshop' &&
            <Route path="/OtpMail" element={<OtpMail />} />
          }
        </Routes> 

        : 
  
        <Layout><Loader loading={true} /></Layout>
      }
    </>
  );
}

export default App;
